import { render, staticRenderFns } from "./FootbowlDisplay.vue?vue&type=template&id=73f3e793&scoped=true&"
import script from "./FootbowlDisplay.vue?vue&type=script&lang=ts&"
export * from "./FootbowlDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./FootbowlDisplay.vue?vue&type=style&index=0&id=73f3e793&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f3e793",
  null
  
)

component.options.__file = "FootbowlDisplay.vue"
export default component.exports